const constants = {
  tokenFormId: 'RequestVerificationTokenForm',
  tokenInputSelector: 'input[name="__RequestVerificationToken"]',
  placeholderImage: '/imgs/misc/placeholder-image.png',
  location: { departure: 'departure', return: 'return' },
  lang: { el: 'el', en: 'en' },
  locale: { el: 'el', en: 'en-gb' },
  crediCards: {
    visa: 'visa',
    amex: 'amex',
    mastercard: 'mastercard',
  },
  extras: {
    manually: 'M',
    auto: 'A',
  },
  paymentType: {
    prepaid: 'prepaid',
    return: 'return',
  },
  breakpoints: {
    desktops: 'desktops',
    devices: 'devices',
  },
  body: {
    activeClassname: 'menu-open',
    overlayClassname: 'has-overlay',
  },
  menu: {
    open: 'open',
    close: 'close',
  },
  view: {
    grid: 'grid',
    list: 'list',
  },
  offerTypes: {
    CDP: 'CDP',
    offerCode: 'OfferCode',
  },
  sort: {
    alpha: 'alpha',
    featured: 'featured',
    ascending: 'ascending',
    descending: 'descending',
  },
  flexdrive: {
    filters: {
      brands: 'brands',
      models: 'models',
      fuels: 'fuels',
      transmissions: 'transmissions',
      prices: 'prices',
      transmissionsOptions: {
        manual: 'Manual',
        auto: 'Automatic',
      },
    },
    fuelType: {
      electic: 'Electric',
    },
  },
  leasing: {
    filters: {
      brands: 'brands',
      models: 'models',
      fuels: 'fuels',
      transmissions: 'transmissions',
      prices: 'prices',
    },
    offerType: {
      default: 'leasingVehicle',
      saver: 'leasingVehicleFlexSaver',
    },
  },
  leaseitnow: {
    sessionStorageKey: 'searchargs',
    sessionStorageConfig: 'carConfig',
    filters: {
      typeOptions: {
        // use _ because private is a reserved word in strict mode
        _private: 'private',
        commercial: 'commercial',
      },
      type: 'type',
      brands: 'brands',
      models: 'models',
      editions: 'editions',
      fuels: 'fuels',
      bodyTypes: 'bodyTypes',
      transmissionsOptions: {
        manual: 'M',
        auto: 'A',
      },
      transmissions: 'transmissions',
      prices: 'prices',
    },
    channel: 'Website',
    hybridStatus: {
      hybrid: 1,
      plugin: 2,
      mildHybrid: 3,
    },
  },
  stores: {
    view: {
      list: 'list',
      map: 'map',
    },
  },
  nodeTypeAlias: {
    homePage: 'hertzHomePage',
    personalPage: 'hertzCreateReservationPersonal',
  },
  bookingBarTheme: { static: 'static' },
}

export default constants
